//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

const SPEED_IN_PX = 250;

export default {
  computed: {
    ...mapGetters('courses', ['computedCoursesBranding']),
    isBr() {
      return this.$nuxt.$config.COUNTRY === 'br';
    },
    isMx() {
      return this.$nuxt.$config.COUNTRY === 'mx';
    },
    tickerBackgroundComputed() {
      return this.computedCoursesBranding?.tickerBackground;
    },
    tickerText1Computed() {
      return this.computedCoursesBranding?.tickerText;
    },
    tickerText2Computed() {
      return this.computedCoursesBranding?.tickerSecondText;
    },
    tickerText1NotEmptyComputed() {
      return this.tickerText1Computed?.length > 0;
    },
    tickerText2NotEmptyComputed() {
      return this.tickerText2Computed?.length > 0;
    },
    tickerTextNotEmpty() {
      return (
        this.tickerText1NotEmptyComputed || this.tickerText2NotEmptyComputed
      );
    },
    tickerIsActiveComputed() {
      return this.computedCoursesBranding?.tickerIsActive;
    },
    computedTickerStyle() {
      return `background: ${this.tickerBackgroundComputed || ''}`;
    },
  },
  watch: {
    tickerTextNotEmpty: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            this.initInfiniteMarquee();
          });
        }
      },
    },
  },
  mounted() {
    if (this.tickerTextNotEmpty) {
      this.$nextTick(() => {
        this.initInfiniteMarquee();
      });
    }
  },
  methods: {
    initInfiniteMarquee() {
      const tickerContainer = this.$refs?.tickerContainer;
      const tickerItems = this.$refs?.tickerItems;
      const TICKER_CONTAINER_WIDTH = 599;
      let tickerItemsWidth;
      if (tickerItems) {
        tickerItemsWidth = tickerItems?.offsetWidth;
        const repeatCount = Math.ceil(
          (TICKER_CONTAINER_WIDTH * 2) / tickerItemsWidth,
        );
        const clones = Array.from({ length: repeatCount }, () =>
          tickerItems.cloneNode(true),
        );
        if (tickerContainer) {
          tickerContainer.append(...clones);
          const totalWidth = tickerItemsWidth * (repeatCount + 1);
          const duration = totalWidth / SPEED_IN_PX;
          tickerItems.style.animation = `scroll-marquee ${duration}s linear infinite`;
          clones.forEach(
            (element) =>
              (element.style.animation = `scroll-marquee ${duration}s linear infinite`),
          );
        }
      }
    },
  },
};
